import { LAYOUTS, POSITION, } from '@voltmoney/types';
import { BorderRadiusTokens, ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, ShimmerIconSizeTokens, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackType, WIDGET } from '@voltmoney/schema';
import { ROUTE } from '../../../routes';
import { ACTION } from './types';
import { horizontalStepperRepo } from '../../../configs/utils';
import { fetchLinkRepo } from './repo';
import { authenticateRepayment, goBack, NavToAutoPay, NavToLoanAgreement, openLinkInNewTab, PollAgreementStatusAction, } from './actions';
import { Platform } from 'react-native';
export const template = (stepper, urlData, height) => ({
    layout: {
        id: ROUTE.LOAN_AGREEMENT,
        type: LAYOUTS.LIST,
        widgets: [
            Platform.OS === "ios" ? { id: 'spaceXXL', type: WIDGET.SPACE, position: POSITION.ABSOLUTE_TOP } : {},
            { id: "headerSpace", type: WIDGET.SPACE },
            { id: "agreementInitPage", type: WIDGET.AGREEMENT_INIT },
        ],
    },
    datastore: {
        agreementInitPage: {
            height: height,
            stepperData: stepper,
            goBackAction: {
                type: ACTION.GO_BACK,
                routeId: ROUTE.LOAN_AGREEMENT,
                payload: {}
            },
            continueAction: {
                type: ACTION.REPAYMENT,
                routeId: ROUTE.LOAN_AGREEMENT,
            },
            urlData: urlData,
            showClickForAgreementCard: false,
            showWaitingForResponseCard: false,
            openTabAction: {
                type: ACTION.OPEN_TAB,
                routeId: ROUTE.LOAN_AGREEMENT,
            },
            pollAgreementStatusAction: {
                type: ACTION.POLL_AGREEMENT_STATUS,
                routeId: ROUTE.LOAN_AGREEMENT,
                payload: {}
            },
            verificationSuccessAction: {
                type: ACTION.GO_TO_AUTOPAY,
                routeId: ROUTE.LOAN_AGREEMENT,
                payload: {}
            },
            showWebView: false
        },
        headerSpace: { size: SizeTypeTokens.NONE },
        spaceXXL: {
            size: SizeTypeTokens.XXL
        },
        headItem: {
            label: 'Review agreement',
            fontSize: FontSizeTokens.MD,
            color: ColorTokens.Grey_Night,
            fontFamily: FontFamilyTokens.Poppins,
            fontWeight: '700',
        },
        headSpace: { size: SizeTypeTokens.MD },
        contentItem: {
            label: 'Verify and confirm the usage terms & charges',
            fontSize: FontSizeTokens.SM,
            color: ColorTokens.Grey_Charcoal,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '400',
        },
        contentSpace: { size: SizeTypeTokens.XXXXXXL },
        iconStack: {
            type: StackType.column,
            justifyContent: StackJustifyContent.center,
            alignItems: StackAlignItems.center,
            widgetItems: [
                { id: 'upsideSpace', type: WIDGET.SPACE },
                { id: 'upsideSpace1', type: WIDGET.SPACE },
                { id: 'iconcontent', type: WIDGET.SHIMMERICON },
                { id: 'downsideSpace', type: WIDGET.SPACE },
                { id: 'downsideSpace1', type: WIDGET.SPACE },
            ],
        },
        upsideSpace: { size: SizeTypeTokens.XXXXL },
        upsideSpace1: { size: SizeTypeTokens.MD },
        downsideSpace: { size: SizeTypeTokens.XXXXL },
        downsideSpace1: { size: SizeTypeTokens.MD },
        iconcontent: {
            icon: {
                name: IconTokens.ContractFile,
                size: IconSizeTokens.XXXXXXXXL,
            },
            name: 'Freebook',
            size: ShimmerIconSizeTokens.XXXXXL,
            borderRadius: BorderRadiusTokens.BR0,
            padding: SizeTypeTokens.SM,
        },
        iconSpace: { size: SizeTypeTokens.XXXXXXL },
        btnData: {
            type: StackType.column,
            justifyContent: StackJustifyContent.center,
            alignItems: StackAlignItems.center,
            widgetItems: [{ id: 'btnItem', type: WIDGET.BUTTON }],
        },
        btnItem: {
            label: 'Continue',
            type: ButtonTypeTokens.LargeFilled,
            labelColor: ColorTokens.White,
            id: "bt_reviewAgreement_Continue",
            width: ButtonWidthTypeToken.FULL,
            action: {
                type: Platform.OS === 'web' ? ACTION.REPAYMENT : ACTION.OPEN_TAB,
                payload: {
                    value: urlData,
                    widgetId: 'input',
                    isResend: false,
                },
                routeId: ROUTE.LOAN_AGREEMENT,
            },
        },
        btnSpace: { size: SizeTypeTokens.XXXL },
    },
});
export const loanAgreementMF = {
    onLoad: async ({ instrumentTrack, network, getHeight }) => {
        instrumentTrack("AGREEMENT_PAGE_VIEWED");
        const stepper = await horizontalStepperRepo(network);
        const responseX = await fetchLinkRepo();
        const urlData = responseX.stepResponseObject;
        return Promise.resolve(template(stepper, urlData, getHeight()));
    },
    actions: {
        [ACTION.REPAYMENT]: authenticateRepayment,
        [ACTION.GO_BACK]: goBack,
        [ACTION.OPEN_TAB]: openLinkInNewTab,
        [ACTION.GO_TO_AUTOPAY]: NavToAutoPay,
        [ACTION.POLL_AGREEMENT_STATUS]: PollAgreementStatusAction,
        [ACTION.GO_TO_LOAN_AGREEMENT]: NavToLoanAgreement,
    },
};
